import serverUrl from '@/assets/BaseServerUrl.js'

const HEALTH_ENDPOINT = `${serverUrl}/api/health`
const CHECK_INTERVAL = 8000
const TIMEOUT = 3000
const FAIL_THRESHOLD = 1

let consecutiveFails = 0
let isServerDown = false
let checkTimer = null
let listeners = []
let checking = false
let initialCheckDone = false

async function checkHealth() {
  if (checking) return
  checking = true
  try {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT)
    const res = await fetch(HEALTH_ENDPOINT, {
      method: 'GET',
      signal: controller.signal,
      cache: 'no-store'
    })
    clearTimeout(timeoutId)

    if (res.ok) {
      const data = await res.json()
      if (data.status === 'ok') {
        consecutiveFails = 0
        if (isServerDown) {
          isServerDown = false
          notifyListeners(false)
          stopPolling()
        }
        initialCheckDone = true
        return
      }
    }
    handleFail()
  } catch (e) {
    handleFail()
  } finally {
    checking = false
  }
}

function handleFail() {
  consecutiveFails++
  if (consecutiveFails >= FAIL_THRESHOLD && !isServerDown) {
    isServerDown = true
    notifyListeners(true)
    startPolling()
  }
  initialCheckDone = true
}

function startPolling() {
  if (checkTimer) return
  checkTimer = setInterval(checkHealth, CHECK_INTERVAL)
}

function stopPolling() {
  if (checkTimer) {
    clearInterval(checkTimer)
    checkTimer = null
  }
}

function notifyListeners(down) {
  listeners.forEach(fn => {
    try { fn(down) } catch (e) { /* ignore */ }
  })
}

export function startHealthCheck() {
  if (initialCheckDone) return
  checkHealth()
}

export function stopHealthCheck() {
  stopPolling()
}

export function onServerStatusChange(fn) {
  listeners.push(fn)
  return () => {
    listeners = listeners.filter(l => l !== fn)
  }
}

export function getServerDownStatus() {
  return isServerDown
}

export function reportNetworkError() {
  if (isServerDown) return
  checkHealth()
}
